<template>
  <div class="navigation common_content">
    <div class="nav">
      <button type="button" class="navbar" @click="changeNav" v-show="navShow">
        <span class="sr-only">Toggle navigation</span>
        <span class="icon-bar"></span>
        <span class="icon-bar"></span>
        <span class="icon-bar"></span>
      </button>
      <ul class="nav_ul" v-show="navShow2">
        <li class="nav_li" v-for="(item, index) in list" :key="index" @click="select(item, index)">
          <router-link :to="item.path">
            <div>{{ item.name }}</div>
            <div v-if="navName == item.path">
              <img src="/image/index/whiteBadminton.png" alt/>
              <div class="sj"></div>
            </div>
          </router-link>
        </li>
      </ul>
      <ul class="nav_ul2" v-show="navShow3">
        <li
            class="nav_li2"
            v-for="(item, index) in list"
            :key="index"
            @click="select2(item, index)"
        >
          <router-link :to="item.path">
            <div>{{ item.name }}</div>
            <div v-if="navName == item.path">
              <div class="sj"></div>
            </div>
          </router-link>
        </li>
      </ul>
    </div>
    <div class="crumbs" v-if="this.$route.meta.crumbsFlag">
      <div class="crumbs_left"></div>
      <div class="crumbs_right">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item
              :to="item.path"
              v-for="(item, index) in realList"
              :key="index"
          >{{ item.title }}
          </el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import {setStore, getStore} from "@/util/store";

export default {
  name: "",
  data() {
    return {
      list: [
        {path: "/index", name: "首页"},
        {path: "/news", name: "新闻动态"},
        {path: "/notice", name: "通知公告"},
        {path: "/test", name: "测试报名"},
        {path: "/evaluationStaff", name: "考评员"},
        {path: "/testInstitutions", name: "测试机构"},
        {path: "/personal", name: "个人中心"},
        {path: "/enquiry/certificateAuthenticity", name: "公开查询"}
      ],
      navShow: false,
      navShow2: true,
      navShow3: false,
      timer: true,
      realList: [],
      navName: "",
    };
  },
  computed: {
    ...mapGetters(["routeList", 'screenWidth'])
  },
  watch: {
    $route() {
      this.checkRouterLocal();
      this.realList = this.routeList;
    },
    routeList(val) {
      // 将面包屑所处的位置存储
      this.realList = val;
      setStore({
        name: "oldrouteList",
        content: val,
        type: "session"
      });
    },
    screenWidth(val) {
      this.navControl(val);
    }
  },
  created() {
    // 路径高亮
    this.checkRouterLocal();
    this.realList = this.routeList;
    // 刷新页面需要将localstore中存储的面包屑重新赋值
    let crumbList = getStore({name: "oldrouteList"});
    if (crumbList) {
      this.$store.commit("SET_ROUTELIST", crumbList);
    }
    this.navControl();
  },
  methods: {
    navControl() {
      if (this.screenWidth < 768) {
        this.navShow = false;
        this.navShow2 = false;
        this.navShow3 = true;
      } else {
        this.navShow = false;
        this.navShow2 = true;
        this.navShow3 = false;
      }
    },
    select() {
    },
    select2() {
      // this.navShow3 = !this.navShow3;
    },
    // 检索当前路径
    checkRouterLocal() {
      // 查找当前路由下标高亮
      this.navName = "/" + this.$route.meta.lightFlag;
    },
    //手机端导航变换
    changeNav() {
      this.navShow3 = !this.navShow3;
    }
  }
};
</script>

<style lang="less">
.navigation {
  .nav {
    font-size: 16px;
    //background: #ea0000 url(/image/index/grid.png);
    background: #b93229;

    .navbar {
      //display: none;
      position: absolute;
      right: 0;
      top: -51px;
      padding: 8px 7px;
      background-color: transparent;
      background-image: none;
      border: 1px solid #ddd;
      border-radius: 4px;

      .sr-only {
        position: absolute;
        width: 1px;
        height: 1px;
        padding: 0;
        margin: -1px;
        overflow: hidden;
        clip: rect(0, 0, 0, 0);
        border: 0;
      }

      .icon-bar {
        display: block;
        width: 22px;
        height: 2px;
        border-radius: 1px;
        background-color: #888;
      }

      .icon-bar + .icon-bar {
        margin-top: 4px;
      }
    }

    .nav_ul {
      width: 85%;
      display: flex;
      margin: 0 auto;
      justify-content: space-between;

      .nav_li {
        margin: 10px 20px;
        position: relative;

        a {
          color: #ffffff;
        }

        img {
          width: 20px;
          position: absolute;
          right: -30px;
          top: -25%;
        }

        .sj {
          position: absolute;
          bottom: -10px;
          left: 34%;
          overflow: hidden;
          font-size: 0;
          line-height: 0;
          border-color: transparent transparent #ffffff transparent;
          border-style: solid;
          border-width: 8px;
        }
      }
    }

    .nav_ul2 {
      .nav_li2 {
        margin: 10px 20px;

        a {
          color: #ffffff;
        }
      }
    }
  }

  .crumbs {
    width: 100%;
    // height: 40px;
    margin: 20px 0px;
    display: flex;
    background: linear-gradient(90deg, #e6e6e6 0%, #ffffff 130%);

    .crumbs_left {
      width: 1%;
      background: #ea0000;
      // height: 40px;
    }

    .crumbs_right {
      line-height: 40px;
    }

    .el-breadcrumb {
      line-height: 40px;
      padding: 0px 10px;
    }

    .el-breadcrumb__item:last-child .el-breadcrumb__inner,
    .el-breadcrumb__item:last-child .el-breadcrumb__inner a,
    .el-breadcrumb__item:last-child .el-breadcrumb__inner a:hover,
    .el-breadcrumb__item:last-child .el-breadcrumb__inner:hover {
      font-weight: 400;
      color: #ea0000;
      cursor: text;
    }
  }
}

@media only screen and (max-width: 1000px) {
  .navigation {
    .nav {
      .nav_ul {
        width: 100%;

        .nav_li {
          margin: 10px 15px;
        }
      }
    }
  }
}

@media only screen and (max-width: 767px) {
  .navigation {
    position: relative;

    .nav {
      background: none;

      .nav_ul2 {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        //position: absolute;
        top: -10px;
        z-index: 999;
        width: 100%;
        padding: 5px 0;
        background: #ea0000 url(/image/index/grid.png);
        text-align: center;

        .nav_li2 {
          // float: left;
          position: relative;
          width: 20%;
          font-size: 15px;
          margin: 7px 7px;

          .sj {
            position: absolute;
            bottom: -10px;
            left: 42%;
            overflow: hidden;
            font-size: 0;
            line-height: 0;
            border-color: transparent transparent #ffffff transparent;
            border-style: solid;
            border-width: 8px;
          }
        }
      }
    }

    .crumbs {
      margin: 0 0 20px 0;
    }
  }
}
</style>
